<template>
  <div>
    <div class="container">
      <e-search
        :data="filterInfo.data"
        :field-list="filterInfo.fieldList"
        :list-type-info="listTypeInfo"
        :count="5"
        @handleFilter="handleSearch"
        @handleReset="handleClear"
      ></e-search>
    </div>

    <div class="container">
      <TableList
        :loading="loading"
        :table-data="tableData"
        :table-label="tableLabel"
        @handleSortChange="handleSortChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <template #status="slot">
          <div style="font-size: 12px">
            {{ formatStatus(slot.scope.row.agreementStatus) }}
          </div>
        </template>
        <template #auditStatusList="slot">
          <div style="font-size: 12px">
            {{ formatAuditStatusList(slot.scope.row.auditStatus) }}
          </div>
        </template>
        <template #agreementName="slot">
          <eui-btn type="link" class="in2clamp" font-size="12px" @click="checkDetail(slot.scope.row)">
            {{ slot.scope.row.agreementName }}
          </eui-btn>
        </template>
        <template #operation="slot">
          <eui-btn
            v-if="Number(slot.scope.row.agreementStatus) !== 6"
            type="link"
            font-size="12px"
            @click.native.prevent="checkProduct(slot.scope.row)"
          >
            商品清单
          </eui-btn>
          <eui-btn
            v-if="Number(slot.scope.row.agreementStatus) == 6 || Number(slot.scope.row.agreementStatus) == 7"
            font-size="12px"
            type="link"
            @click.native.prevent="checkDetail(slot.scope.row)"
          >
            查看
          </eui-btn>
          <eui-btn
            v-if="[3, 5].includes(slot.scope.row.auditStatus)"
            font-size="12px"
            type="link"
            @click.native.prevent="handleEdit(slot.scope.row)"
          >
            编辑
          </eui-btn>
          <eui-btn
            v-if="slot.scope.row.agreementStatus == 1 || slot.scope.row.agreementStatus == 2"
            type="link"
            font-size="12px"
            @click.native.prevent="handleGoodsMaintenance(slot.scope.row)"
          >
            维护商品
          </eui-btn>
          <eui-btn type="link" font-size="12px" @click.native.prevent="onPriceLinkage(slot.scope.row)">
            价格联动
          </eui-btn>
          <eui-btn type="link" font-size="12px" @click.native.prevent="openLowActivity(slot.scope.row)">
            低活商品
          </eui-btn>
        </template>
        <template #agreementCode="slot">
          <div style="text-align: center">
            <p style="font-size: 12px; text-align: left; display: inline-block">
              {{ slot.scope.row.agreementCode }}
            </p>
          </div>
        </template>
        <template #firstParty="slot">
          <div style="font-size: 12px; text-align: left">
            {{ slot.scope.row.firstCompanyName }}
          </div>
        </template>
        <template #startDate="slot">
          <div style="text-align: center">
            <div style="font-size: 12px">{{ slot.scope.row.tmpStartDate }}</div>
          </div>
        </template>
        <template #endDate="slot">
          <div style="text-align: center">
            <div style="font-size: 12px">{{ slot.scope.row.tmpEndDate }}</div>
          </div>
        </template>
        <template #supplierCompanyName="slot">
          <div style="font-size: 12px; text-align: left">
            {{ slot.scope.row.supplierCompanyName }}
          </div>
        </template>
      </TableList>
      <div class="pagination">
        <el-pagination
          :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="productTagPage.currentPage"
          :page-size="productTagPage.pageSize"
          :total="productTagPage.pageTotal"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
      <product-list-dialog
        v-if="productListDialogShow"
        :supplier-company-id="supplierCompanyId"
        :agreement-id="agreementId"
        :visible="productListDialogShow"
        @close="closeProductListDialog"
      ></product-list-dialog>
    </div>
    <price-linkage-dialog :visible.sync="priceLinkageShow" :info="info" @success="getAgreementList()" />

    <LowActivityDialog v-if="lowActivityVisible" :visible.sync="lowActivityVisible" :info="info"></LowActivityDialog>
  </div>
</template>

<script>
import TableList from '../../components/common/e-table-list';
import ProductListDialog from '../../components/agreement/agreementManage/sharedResourceProductDialog';
import agreementApi from '../../api/agreement/index';
import ESearch from '../../components/common/e-search';
import priceLinkageDialog from './components/priceLinkageDialog';
import LowActivityDialog from './components/lowActivityDialog';

export default {
  components: {
    TableList,
    ProductListDialog,
    priceLinkageDialog,
    ESearch,
    LowActivityDialog,
  },
  props: {},
  data() {
    return {
      lowActivityVisible: false,
      query: {
        agreementStatus: '',
        agreementCode: '',
        agreementName: '',
      },
      loading: false,
      tableData: [],
      tableLabel: [
        {
          label: '协议编号',
          param: 'agreementCode',
          align: 'center',
          minWidth: '200',
          slot: 'agreementCode',
        },
        {
          label: '协议名称',
          param: 'agreementName',
          align: 'center',
          slot: 'agreementName',
          minWidth: '200',
        },
        {
          label: '甲方名称',
          param: 'firstCompanyName',
          align: 'center',
          minWidth: '200',
          slot: 'firstParty',
        },
        {
          label: '开始时间',
          param: 'startDate',
          align: 'center',
          minWidth: '100',
          slot: 'startDate',
        },
        {
          label: '结束时间',
          param: 'endDate',
          align: 'center',
          minWidth: '100',
          slot: 'endDate',
        },

        {
          label: '协议状态',
          param: 'agreementStatus',
          align: 'center',
          slot: 'status',
          minWidth: '100',
        },
        {
          label: '审核状态',
          param: 'agreementStatus',
          align: 'center',
          slot: 'auditStatusList',
          minWidth: '100',
        },
        {
          label: '是否价格联动',
          param: 'priceLinkage',
          align: 'center',
          minWidth: '100',
          render({ priceLinkage }) {
            return priceLinkage ? '是' : '否';
          },
        },
        {
          label: '创建时间',
          param: 'createTime',
          align: 'center',
          minWidth: '140',
        },
        {
          label: '操作',
          align: 'center',
          slot: 'operation',
          minWidth: '240',
          fixed: 'right',
        },
      ],
      productTagPage: {
        currentPage: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      purchaserListDialogShow: false,
      productListDialogShow: false,
      priceLinkageShow: false,
      dialogTitle: '采购商列表',
      agreementId: null,
      supplierCompanyId: null,
      filterInfo: {
        data: {
          agreementStatus: '',
          agreementCode: '',
          agreementName: '',
          auditStatus: null,
        },
        fieldList: [
          { label: '协议编号', type: 'input', value: 'agreementCode' },
          { label: '协议名称', type: 'input', value: 'agreementName' },
          {
            label: '协议状态',
            type: 'select',
            value: 'agreementStatus',
            list: 'statusList',
          },
          {
            label: '审核状态',
            type: 'select',
            value: 'auditStatus',
            list: 'auditStatusList',
          },
        ],
        /** 搜索/重置区域是否隐藏 */
        // btnHidden: true,
        /** 组件尺寸 */
        // size: 'small',
        /** 默认展示搜索条件 */
        count: 100,
        /** label/item 宽度 */
        // width: {
        //   labelWidth: 110,
        //   itemWidth: 220
        // },
        /** 配置项 */
        btnStyle: [
          { icon: 'el-icon-search', text: '过滤', type: 'primary' },
          { icon: 'el-icon-refresh', text: '重置' },
        ],
      },
      listTypeInfo: {
        statusList: [
          // { id: 0, name: '待维护商品' },
          { id: 1, name: '待生效' },
          { id: 2, name: '已生效' },
          { id: 5, name: '已停用' },
          // { id: 4, name: '待审核商品' },
          // { id: 3, name: '已失效' },
          // { id: 6, name: '待平台审核' },
          // { id: 7, name: '审核拒绝' },
        ],
        // 审核状态  1-待审核 2-审核通过 3-审核拒绝
        auditStatusList: [
          { id: null, name: '全部' },
          { id: 1, name: '待初审' },
          { id: 4, name: '待复审' },
          { id: 2, name: '审核通过' },
          { id: 3, name: '初审拒绝' },
          { id: 5, name: '复审拒绝' },
        ],
      },
      info: {},
    };
  },
  computed: {},
  created() {
    this.getAgreementList();
  },
  methods: {
    /* 低活商品开始 */
    openLowActivity(row) {
      this.info = row;
      this.lowActivityVisible = true;
    },
    /* 低活商品结束 */
    handleAddAgreement() {
      this.$router.push({ path: '/agreementAdd' });
    },
    handleSearch(val) {
      this.filterInfo.data = val;
      this.productTagPage.currentPage = 1;
      this.productTagPage.pageSize = 10;
      const params = this.formatParams(val);
      this.getAgreementList(params);
    },
    handleClear() {
      this.filterInfo.data.agreementCode = '';
      this.filterInfo.data.agreementName = '';
      this.filterInfo.data.agreementStatus = '';
      this.filterInfo.data.auditStatus = null;
      const params = {
        pageNum: 1,
        pageSize: 10,
        agreementCode: '',
        agreementName: '',
        agreementStatus: '',
        auditStatus: null,
      };
      this.getAgreementList(params);
    },
    handleSortChange() {},
    handleSelectionChange() {},
    handleSizeChange(val) {
      this.productTagPage.pageSize = val;
      this.productTagPage.currentPage = 1;
      const params = {
        pageNum: this.productTagPage.currentPage,
        pageSize: this.productTagPage.pageSize,
        agreementCode: this.filterInfo.data.agreementCode,
        agreementName: this.filterInfo.data.agreementName,
        agreementStatus: this.filterInfo.data.agreementStatus,
      };
      this.getAgreementList(params);
    },
    handleCurrentChange(val) {
      this.productTagPage.currentPage = val;
      const params = {
        pageNum: this.productTagPage.currentPage,
        pageSize: this.productTagPage.pageSize,
        agreementCode: this.filterInfo.data.agreementCode,
        agreementName: this.filterInfo.data.agreementName,
        agreementStatus: this.filterInfo.data.agreementStatus,
      };
      this.getAgreementList(params);
    },
    handleEdit(val) {
      const params = {
        agreementId: val.agreementId,
      };
      agreementApi.getAgreementDetail(params).then((res) => {
        if (res.data) {
          this.$router.push({
            path: '/agreementEdit',
            query: { agreementData: JSON.stringify(res.data) },
          });
        }
      });
    },
    handleDelete(val) {
      this.$confirm('协议删除后不可恢复，确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          const params = {
            agreementId: val.agreementId,
          };
          agreementApi.deleteAgreement(params).then((res) => {
            if (res.code === '200') {
              this.$message({
                type: 'success',
                message: '删除成功!',
              });
            } else {
              this.$message({
                type: 'error',
                message: '删除失败!',
              });
            }
            this.getAgreementList();
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    handleStop(val) {
      this.$confirm('协议停用后协议将失效，确认停用吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          const params = {
            agreementId: val.agreementId,
          };
          agreementApi.stopAgreement(params).then((res) => {
            if (res.code === '200') {
              this.$message({
                type: 'success',
                message: '停用成功!',
              });
            } else {
              this.$message({
                type: 'error',
                message: '停用失败!',
              });
            }
            this.getAgreementList();
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消停用',
          });
        });
    },
    handleStart(val) {
      this.$confirm('确认启用吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          const params = {
            agreementId: val.agreementId,
          };
          agreementApi.startAgreement(params).then((res) => {
            if (res.code === '200') {
              this.$message({
                type: 'success',
                message: '启用成功!',
              });
            } else {
              this.$message({
                type: 'error',
                message: '启用失败!',
              });
            }
            this.getAgreementList();
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消启用',
          });
        });
    },
    handleConfirmPrice(val) {
      const params = {
        agreementId: val.agreementId,
      };
      agreementApi.getSharedAgreementDetail(params).then((res) => {
        if (res.data) {
          this.$router.push({
            name: 'agreementConfirm',
            params: { agreementDetail: JSON.stringify(res.data) },
          });
        }
      });
    },
    onPriceLinkage(data) {
      this.info = data;
      this.priceLinkageShow = true;
    },
    handleGoodsMaintenance(val) {
      const params = {
        agreementId: val.agreementId,
      };
      agreementApi.getSharedAgreementDetail(params).then((res) => {
        if (res.data) {
          this.$router.push({
            name: 'sharedResourceGoodsMaintenance',
            query: { agreementId: val.agreementId },
          });
        }
      });
    },
    handleEdit(val) {
      this.$router.push({ path: '/shareAgreementEdit', query: { agreementId: val.agreementId } });
    },
    checkDetail(val) {
      this.$router.push({
        path: '/sharedResourceAgreementDetail',
        query: { agreementId: val.agreementId },
      });
    },
    checkProduct(val) {
      this.productListDialogShow = true;
      this.agreementId = val.agreementId;
      this.supplierCompanyId = val.secondCompanyId;
    },
    checkPurchaser(val) {
      this.agreementId = val.agreementId;
      this.purchaserListDialogShow = true;
    },
    closeProductListDialog() {
      this.productListDialogShow = false;
    },
    closePurchaserListDialog() {
      this.purchaserListDialogShow = false;
    },
    getAgreementList(val) {
      // let params = this.formatParams(val);
      agreementApi
        .getProductPriceListShared(val)
        .then((res) => {
          this.tableData = res.data.records;
          this.productTagPage.pageTotal = res.data.total;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    formatParams(params) {
      const res = {};
      res.agreementCode = params.agreementCode;
      res.agreementName = params.agreementName;
      res.agreementStatus = params.agreementStatus;
      res.auditStatus = params.auditStatus;
      res.pageSize = this.productTagPage.pageSize;
      res.pageNum = this.productTagPage.currentPage;
      return res;
    },
    formatStatus(val) {
      let res = '';
      this.listTypeInfo.statusList.map((item) => {
        if (item.id == val) {
          res = item.name;
        }
      });
      return res;
    },
    formatAuditStatusList(val) {
      let res = '';
      if (val) {
        this.listTypeInfo.auditStatusList.map((item) => {
          if (item.id == val) {
            res = item.name;
          }
        });
      }
      return res;
    },
    judgePurchaser(val) {
      return val.epecBelongCompanyId == JSON.parse(localStorage.getItem('USERINFO')).companyId;
    },
    judgeDoubleIdentity(val) {
      return (
        (JSON.parse(localStorage.getItem('USERINFO')).identity == 'double_identity' ||
          JSON.parse(localStorage.getItem('USERINFO')).identity == 'supplier') &&
        JSON.parse(localStorage.getItem('USERINFO')).companyId == val.supplierCompanyId
      );
    },
  },
};
</script>

<style scoped lang="scss">
.e-search {
  margin-bottom: 20px;
}
</style>
